import React, { FC, useEffect, useState, MouseEventHandler } from 'react';
import cx from 'classnames';

import { ButtonPrimary, ButtonSecondary } from '@/components/atoms/renders';

import block from '../block.json';
import { getStyles } from './styles.css';

/**
 * TYPINGS
 */
type GdprBannerProps = {
	bannerDismissed: boolean;
	texts: object;
	onPersonalizeClick: MouseEventHandler;
	onAcceptClick: Function;
	onRejectClick: Function;
} & ThemeProps;

/**
 * COMPONENT
 */
export const GdprBanner: FC<GdprBannerProps> = ({
	bannerDismissed,
	texts,
	onAcceptClick,
	onPersonalizeClick,
	onRejectClick,
	theme = {},
}) => {
	const [isHidden, setIsHidden] = useState(true);

	useEffect(() => {
		if (bannerDismissed) hide();
		else show();
	}, [bannerDismissed]);

	const handleAcceptClick = (event) => {
		event.stopPropagation();

		onAcceptClick();

		setIsHidden(true);
	};

	const handleRejectClick = (event) => {
		event.stopPropagation();

		onRejectClick();

		setIsHidden(true);
	};

	const show = () => {
		setIsHidden(false);
	};

	const hide = () => {
		setIsHidden(true);
	};

	const rootClass = cx('supt-gdprBanner', getStyles(theme));

	return (
		<div
			className={rootClass}
			role="dialog"
			aria-live="polite"
			aria-hidden={isHidden}
			aria-label="cookie-law-banner:title"
			aria-describedby="cookie-law-banner:desc"
			data-block={block.slug}
		>
			<div className="supt-gdprBanner__inner">
				<h2
					id="cookie-law-banner:title"
					className="supt-gdprBanner__title"
				>
					{texts['title']}
				</h2>

				<div
					id="cookie-law-banner:desc"
					className="supt-gdprBanner__message"
				>
					<p
						dangerouslySetInnerHTML={{
							__html: texts['message'],
						}}
					/>
				</div>

				<div className="supt-gdprBanner__buttons">
					<ButtonPrimary
						title={texts['acceptAll']}
						className="supt-gdprBanner__acceptButton"
						onClick={handleAcceptClick}
					/>

					<ButtonSecondary
						title={texts['personalize']}
						className="supt-gdprBanner__personalizeButton"
						onClick={onPersonalizeClick}
					/>

					<button
						className="supt-gdprBanner__rejectButton"
						onClick={handleRejectClick}
					>
						<span className="supt-gdprBanner__rejectButton__inner">
							<span>{texts['rejectAll']}</span>
						</span>
					</button>
				</div>
			</div>
		</div>
	);
};
